export function subscribeToEvent(target, type, cb, options) {
  target.addEventListener(type, cb, options);

  return () => {
    target.removeEventListener(type, cb, options);
  };
}



// WEBPACK FOOTER //
// ./src/lib/tools/event-subscribe.js